// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Othr0RSmQ0uqVLNApjnR9","icon":"_1AzK3HGRRfHYuS1pGqTia1"};